import { defineComponent as _defineComponent } from 'vue'
import { computed, useStore } from "@nuxtjs/composition-api";

import { useLinkService, useTranslate } from "@/composables";
import { getProfilesStore } from "@/store/profiles";


export default /*#__PURE__*/_defineComponent({
  __name: 'LtkShopAvatar',
  props: {
  profileId: {
    type: String,
    required: true,
  },
  size: {
    type: [String, Number],
    default: 33,
  },
},
  setup(__props) {

const props = __props;

/**
 * Component to uniformly render an LTK Imagesizer enabled avatar. Relies on some progressive feature
 * detection to provide a correct image format (webp/jpg) and DPR.
 * @todo Should probably get formalized into the component library at some point:
 * - generic imagesizer image component (Maybe CImage makes enough sense)
 * - preset avatar, hero image, and product image components for URL forming purposes
 * - feature detection becomes a mandatory plugin
 */

const linkService = useLinkService();
const store = useStore();
const { t } = useTranslate();



const profile = computed(() => {
  const profilesStore = getProfilesStore(store);
  return profilesStore.profiles[props.profileId ?? ""];
});

const avatarUrl = computed(() => {
  // CLtkAvatar -> CImage will handle an empty string url as an invalid request, showing the missing profile image
  if (profile.value?.avatarUrl === undefined) {
    return "";
  }

  const imageSize = "100";
  return linkService.getImageLink({ url: profile.value?.avatarUrl, width: imageSize, height: imageSize });
});

const displayName = computed(() => profile.value?.displayName ?? t("My Shop").value);

const altText = t("{influencerName} on LTK", { influencerName: displayName.value });

return { __sfc: true,linkService, store, t, props, profile, avatarUrl, displayName, altText }
}

})